// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.MessageSeverityType
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSEnum.vm
// If you need to 'extend' the enum, create another file with module of the same name and add functions to it...

export let MessageSeverityType = /*#__PURE__*/function (MessageSeverityType) {
  MessageSeverityType[MessageSeverityType["NONE"] = 0] = "NONE";
  MessageSeverityType[MessageSeverityType["ERROR"] = 1] = "ERROR";
  MessageSeverityType[MessageSeverityType["WARNING"] = 2] = "WARNING";
  MessageSeverityType[MessageSeverityType["INFO"] = 3] = "INFO";
  MessageSeverityType[MessageSeverityType["DEBUG"] = 4] = "DEBUG";
  return MessageSeverityType;
}({});
(function (_MessageSeverityType) {
  function fromJson(enumVal) {
    // Canonically always return numeric representation of enum (NOT a string!)
    // An enumVal of either string or number will return undefined if invalid (out of range)
    return typeof enumVal === "number"
    // For safety, check for number in range, if not return undefined
    ? MessageSeverityType[enumVal] != null ? enumVal : undefined : MessageSeverityType[enumVal];
  }
  _MessageSeverityType.fromJson = fromJson;
  function name(enumIndex) {
    return this[enumIndex];
  }
  _MessageSeverityType.name = name;
  function indexOf(enumVal) {
    return enumVal; // Erasure....
  }
  _MessageSeverityType.indexOf = indexOf;
})(MessageSeverityType || (MessageSeverityType = {}));
//# sourceMappingURL=MessageSeverityType.js.map
